import { render } from "./VaDatetime.vue?vue&type=template&id=3ee4b520&scoped=true"
import script from "./VaDatetime.vue?vue&type=script&lang=js"
export * from "./VaDatetime.vue?vue&type=script&lang=js"

import "./VaDatetime.vue?vue&type=style&index=0&id=3ee4b520&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ee4b520"]])

export default __exports__